import { useCallback, useEffect, useState } from 'react';
import {
  AppModal,
  AppNoInfo,
  AppNotificationAlert,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import styled from 'styled-components';
import { FieldArray, Formik } from 'formik';
import { Accordion } from 'react-bootstrap';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import colors from '../../../../../../../constants/colors';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import _ from 'lodash';

export default function HaizeaPenaltyRiskTab(props) {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState();
  const [isEditable, setIsEditable] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  const checkDependencies = useCallback(async () => {
    await axios
      .post(
        axiosPath(
          "api_r_user_module_legalCompliance_haizeaPenaltyRisk_checkDependencies"
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      )
      .then(({ data }) => {
        setIsEditable(data);
      });
  }, []);

  const update = useCallback(async (values) => {
    await axios
      .post(
        axiosPath("api_r_user_module_legalCompliance_haizeaPenaltyRisk_update"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          values,
        }
      )
      .then(({ data }) => {
        const currentData = poLevel3?.[plantObligationID];

        dispatch(
          currentPageAction.change(
            "plantObligationLevels",
            {
              level3: {
                ...poLevel3,
                [plantObligationID]: {
                  ...currentData,
                  haizea: data?.haizea,
                },
              },
            },
            false
          )
        );

        AppNotificationAlert({
          title: "Riesgos penales",
          message: "Se ha guardado correctamente los cambios",
          type: "success",
          duration: 5000,
          position: "top-right",
        });
      });
  }, []);

  const deleteTask = useCallback((values, setFieldValue, index) => {
    const newArrayElements = values.directions.filter(
      (argTask, i) => index !== i
    );
    setFieldValue('directions', newArrayElements);
  }, []);

  const loadData = useCallback(async () => {
    await axios
      .post(
        axiosPath("api_r_user_module_legalCompliance_haizeaPenaltyRisk_tab"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      )
      .then(({ data }) => {
        if (_.isArray(data) && !_.isEmpty(data)) {
          setInitialValues({
            category: null,
            directions: data.map((task) => ({
              probability: task?.riskInherent?.probability?.data,
              impact: task?.riskInherent?.impact?.data,
              riskResidual: task?.riskResidual?.data,
              type: task?.type,
            })),
          });
          return;
        }
        setInitialValues({
          directions: [],
          category: null,
        });
      });
  }, []);

  useEffect(() => {
    loadData();
    checkDependencies();
  }, []);

  const [directionsArray] = useState([
    {
      label: 'Dirección general',
      value: 0,
    },
    {
      label: 'Dirección Financiera - Corporativo',
      value: 1,
    },
    {
      label: 'Dirección de Control, Reporte e Integración - Corporativo',
      value: 2,
    },
    {
      label: 'Dirección Legal - Corporativo',
      value: 3,
    },
    {
      label: 'Dirección Comercial - Corporativo',
      value: 4,
    },
    {
      label: 'Dirección de Compras',
      value: 5,
    },
    {
      label: 'Dirección de Operaciones - Torres',
      value: 6,
    },
    {
      label: 'Dirección de Operaciones - Cimentaciones',
      value: 7,
    },
    {
      label:
        'Dirección de Seguridad, Salud y Medio Ambiente (HSE) - Corporativo',
      value: 8,
    },
    {
      label: 'Dirección de Recursos Humanos',
      value: 9,
    },
    {
      label: 'Dirección de calidad',
      value: 10,
    },
    {
      label: 'Responsable de Tecnologías de la Información y la Comunicación (TIC)',
      value: 11,
    },
    {
      label: 'Responsable de Integración, Marketing y Comunicación - Corporativo',
      value: 12,
    },
    {
      label: 'Responsable de Administración',
      value: 13,
    },
    {
      label: 'Responsable de Compras',
      value: 14,
    },
    {
      label: 'Responsable de Prevención y Medioambiente (HSE)',
      value: 15,
    },
    {
      label: 'Responsable de Calidad & de Control de Producción en Fábrica',
      value: 16,
    },
    {
      label: 'Responsable de Ingeniería – Oficina Técnica',
      value: 17,
    },
    {
      label: 'Operaciones',
      value: 18,
    },
    {
      label: 'Responsable de Recursos Humanos (RRHH)',
      value: 19,
    },
    {
      label: 'Responsable de Sistemas',
      value: 20,
    },
    {
      label: 'Dirección General – Zestoa',
      value: 21,
    },
    {
      label: 'Dirección Financiera – Zestoa',
      value: 22,
    },
    {
      label: 'Dirección de Cadena de Suministros – Zestoa',
      value: 23,
    },
    {
      label: 'Dirección de Calidad y Sistemas – Zestoa',
      value: 24,
    },
    {
      label: 'Responsable de Prevención de Riesgos Laborales (PRL) y Medio Ambiente – Zestoa',
      value: 25,
    },
    {
      label: 'Dirección de Personas (RRHH) – Zestoa',
      value: 26,
    },
    {
      label: 'Responsable de Tecnologías de la Información y de la Comunicación – Zestoa',
      value: 27,
    },
    {
      label: 'Dirección de Mejora Continua – Zestoa',
      value: 28,
    },
    {
      label: 'Dirección de WT&BC',
      value: 29,
    },
    {
      label: 'Dirección de Planta de Fundición',
      value: 30,
    },
    {
      label: 'Dirección de Fundiciones II',
      value: 31,
    },
    {
      label: 'Dirección de Mecanizado y Tratamiento Superficial',
      value: 32,
    },
    {
      label: 'Responsable de Integración, Marketing y Comunicación – HWG',
      value: 33,
    },
    {
      label: 'Dirección Legal – HWG',
      value: 34,
    },
    {
      label: 'Dirección de Control, Reporte e Integración – HWG',
      value: 35,
    },
    {
      label: 'Dirección Financiera – HWG',
      value: 36,
    },
    {
      label: 'Dirección de Planta / Dirección Industrial',
      value: 37,
    },
  ]);

  const [probabilityArray] = useState({
    workers: [
      {
        label: '¿Número de empleados en el departamento?',
        value: 0,
      },
      {
        label: '1 Empleado',
        value: 1,
      },
      {
        label: 'Entre 2 y 5 empleados',
        value: 2,
      },
      {
        label: 'Entre 6 y 10 empleados',
        value: 3,
      },
      {
        label: 'Más de 10 empleados',
        value: 4,
      },
    ],
    supervision: [
      {
        label: '¿Distribución y supervisión?',
        value: 0,
      },
      {
        label:
          'Las operaciones están distribuidas a personal específico y son supervisadas',
        value: 1,
      },
      {
        label:
          'Las operaciones no están especificamente distribuidas, pero son supervisadas',
        value: 2,
      },
      {
        label:
          'Las operaciones están especificamente distribuidas, pero no son supervisadas',
        value: 3,
      },
      {
        label:
          'Las operaciones no están distribuidas, ni tampoco son supervisadas',
        value: 4,
      },
    ],
    training: [
      {
        label: '¿Formación?',
        value: 0,
      },
      {
        label:
          'El personal ha recibido formación específica y ésta se actualiza periódicamente',
        value: 1,
      },
      {
        label:
          'El personal responsable ha recibido formación específica puntual',
        value: 2,
      },
      {
        label: 'El personal responsable ha recibido formación general',
        value: 3,
      },
      {
        label:
          'El personal responsable no ha recibido ningún tipo de formación',
        value: 4,
      },
    ],
    probability: [
      {
        label: 'Probabilidad del riesgo',
        value: '0%',
      },
      {
        label: 'La probabilidad de que se materialice el riesgo es baja',
        value: '25%',
      },
      {
        label: 'La probabilidad de que se materialice el riesgo es media',
        value: '50%',
      },
      {
        label: 'La probabilidad de que se materialice el riesgo es media-alta',
        value: '75%',
      },
      {
        label: 'La probabilidad de que se materialice el riesgo es alta',
        value: '100%',
      },
    ],
  });

  const [impactArray] = useState({
    penalty: [
      {
        label: '¿Pena asociada al delito?',
        value: 0,
      },
      {
        label: 'Multa de hasta 2 años o hasta el triple del valor',
        value: 1,
      },
      {
        label: 'Multa de hasta 3 años o hasta el cuádruple del valor',
        value: 2,
      },
      {
        label: 'Multa de hasta 5 años o el quíntuple del valor',
        value: 3,
      },
      {
        label: 'Multa y pena de inhabilitación',
        value: 4,
      },
    ],
    capacityAnswer: [
      {
        label: '¿Capacidad de respuesta de la organización?',
        value: 0,
      },
      {
        label: 'La actividad de la organización no se ve afectada',
        value: 1,
      },
      {
        label: 'Se ve afectada de forma leve en este departamento',
        value: 2,
      },
      {
        label: 'Reducción importante en el departamento afectado',
        value: 3,
      },
      {
        label: 'Reducción importante general en la organización',
        value: 4,
      },
    ],
    damageReputation: [
      {
        label: '¿Daño reputacional sufrido por la organización?',
        value: 0,
      },
      {
        label: 'La reputación no se ve afectada',
        value: 1,
      },
      {
        label: 'La reputación se ve afectada levemente',
        value: 2,
      },
      {
        label: 'La reputación se ve altamente afectada',
        value: 3,
      },
      {
        label: 'La reputación no será la de antes',
        value: 4,
      },
    ],
    impact: [
      {
        label: 'Impacto del riesgo',
        value: '0%',
      },
      {
        label: 'El impacto de la organización es bajo',
        value: '25%',
      },
      {
        label: 'El impacto de la organización es medio',
        value: '50%',
      },
      {
        label: 'El impacto de la organización es medio-alto',
        value: '75%',
      },
      {
        label: 'El impacto de la organización es alto',
        value: '100%',
      },
    ],
  });

  const [riskResidualArray] = useState({
    prevent: [
      {
        label: 'No se aplican',
        value: 0,
      },
      {
        label: 'Hasta 20 controles',
        value: 0.25,
      },
      {
        label: 'Hasta 30 controles',
        value: 0.5,
      },
      {
        label: 'Hasta 40 controles',
        value: 0.75,
      },
      {
        label: '41 controles o más',
        value: 1.5,
      },
    ],
    detect: [
      {
        label: 'No se aplican',
        value: 0,
      },
      {
        label: 'Hasta 10 controles',
        value: 0.25,
      },
      {
        label: 'Entre 11 y 20 controles',
        value: 0.5,
      },
      {
        label: 'Entre 21 y 30 controles',
        value: 0.75,
      },
      {
        label: '31 controles o más',
        value: 1.5,
      },
    ],
    automatic: [
      {
        label: 'No se aplican',
        value: 0,
      },
      {
        label: 'Hasta 2 controles',
        value: 0.25,
      },
      {
        label: 'Hasta 5 controles',
        value: 0.5,
      },
      {
        label: 'Hasta 10 controles',
        value: 0.75,
      },
      {
        label: '11 o más controles',
        value: 1.5,
      },
    ],
    manual: [
      {
        label: 'No se aplican',
        value: 0,
      },
      {
        label: 'Hasta 10 controles',
        value: 0.25,
      },
      {
        label: 'Entre 11 y 20 controles',
        value: 0.5,
      },
      {
        label: 'Entre 21 y 30 controles',
        value: 0.75,
      },
      {
        label: '31 o más controles',
        value: 1.5,
      },
    ],
    fullControl: [
      {
        label: 'No se aplican',
        value: 0,
      },
      {
        label: 'Hasta 20 controles',
        value: 0.25,
      },
      {
        label: 'Hasta 30 controles',
        value: 0.5,
      },
      {
        label: 'Hasta 40 controles',
        value: 1,
      },
      {
        label: '41 o más controles',
        value: 2,
      },
    ],
    ineffectiveControl: [
      {
        label: 'No',
        value: 0,
      },
      {
        label: 'Si',
        value: 1,
      },
    ],
  });

  const getRiskInherent = useCallback((id = 0) => {
    const table = [
      1,
      1,
      1,
      2,
      2,
      3,
      3,
      3,
      3,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
    ];

    return id === 0 ? 0 : table[id - 1];
  }, []);

  const getColorInherent = useCallback((value = 0) => {
    if (value <= 5) return 'success';
    if (value <= 10) return 'warning';
    return 'danger';
  }, []);

  const calculareRiskInherent = useCallback((values, position) => {
    const { impact, probability } = values.directions[position];

    const levelProbability = getRiskInherent(
      Math.round(
        (probability.workers + probability.supervision + probability.training) *
        (parseFloat(probability.probability) / 100)
      )
    );
    const levelImpact = getRiskInherent(
      Math.round(
        (impact.penalty + impact.capacityAnswer + impact.damageReputation) *
        (parseFloat(impact.impact) / 100)
      )
    );

    const riskInherent = levelProbability * levelImpact;

    return {
      color: getColorInherent(riskInherent),
      value: riskInherent,
    };
  }, []);

  const getColorResidual = useCallback((value = 0) => {
    if (value <= 3) return 'success';
    if (value <= 10) return 'warning';
    return 'danger';
  }, []);

  const calculateRiskResidual = useCallback((values, position) => {
    const { value: valueRiskInherent } = calculareRiskInherent(
      values,
      position
    );
    const { riskResidual } = values.directions[position];
    const riskResidualValue = parseFloat(
      (valueRiskInherent -
        (riskResidual.prevent +
          riskResidual.detect +
          riskResidual.automatic +
          riskResidual.manual +
          riskResidual.fullControl)).toFixed(1)
    );

    return {
      value: riskResidualValue,
      color: getColorResidual(riskResidualValue),
    };
  }, []);

  if (!initialValues) return <AppNoInfo minHeight={300} />;

  if (!isEditable) {
    return (
      <ContainerEmpty>
        <AppNoInfo
          icon={<AppRemixIcon icon="cloud-off" color="#ccc" size={34} />}
          text="Se han encontrado obligaciones con riesgos penales"
        />
      </ContainerEmpty>
    );
  }

  return (
    <Container>
      <Formik
        initialValues={initialValues}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={update}
      >
        {({ setFieldValue, handleSubmit, values, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <div className="pb-3">
              <FieldArray
                name="directions"
                render={(arrayHelpers) => (
                  <>
                    <div className="d-flex flex-row mb-2">
                      <AppSingleSelect
                        options={directionsArray}
                        title="Seleccionar nueva categoría"
                        value={values?.category}
                        onChange={(v) => setFieldValue('category', v)}
                      />
                      <button
                        type="button"
                        disabled={_.isNull(values.category)}
                        className="btn btn-primary btn-sm ml-2"
                        style={{ padding: '0.25rem', marginTop: '0.5rem', marginBottom: '0.5rem' }}
                        onClick={() => {
                          arrayHelpers.push({
                            probability: {
                              workers: 0,
                              supervision: 0,
                              training: 0,
                              probability: '0%',
                            },
                            impact: {
                              penalty: 0,
                              capacityAnswer: 0,
                              damageReputation: 0,
                              impact: '0%',
                            },
                            riskResidual: {
                              prevent: 0,
                              detect: 0,
                              automatic: 0,
                              manual: 0,
                              fullControl: 0,
                              ineffectiveControl: 0,
                            },
                            type: values?.category,
                          });
                          setFieldValue('category', null);
                        }}
                      >
                        Añadir
                      </button>
                    </div>
                    <div>
                      <Accordion>
                        {values.directions &&
                          values.directions.map((m, index) => (
                            <AccordionContainer key={index} className="border">
                              <Accordion.Toggle
                                as="div"
                                className="ac-header"
                                eventKey={`accordion${index}`}
                              >
                                <div className="row">
                                  <div className="col-lg-12">
                                    <div className="d-flex justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <h3>
                                          {`${directionsArray[m?.type].label} `}
                                        </h3>
                                      </div>
                                      <div className="d-flex flex-row align-items-center">
                                        <span
                                          className={`badge badge-${calculareRiskInherent(values, index)
                                            .color
                                            } ml-2`}
                                        >{`RI: ${calculareRiskInherent(values, index)
                                          .value
                                          }`}
                                        </span>
                                        <span
                                          className={`badge badge-${calculateRiskResidual(values, index)
                                            .color
                                            } ml-2`}
                                        >{`RR: ${calculateRiskResidual(values, index)
                                          .value
                                          }`}
                                        </span>
                                        <div className="ml-2">
                                          <AppRemixIcon
                                            icon="delete-bin"
                                            color={colors.danger}
                                            className="pointer"
                                            filled
                                            size={20}
                                            onClick={(event) => {
                                              event.stopPropagation();
                                              setShowModalDelete(index);
                                            }}
                                          />
                                          <AppModal
                                            title="Borrar riesgo penal"
                                            size="xl"
                                            isConfirmBtn
                                            confirmBtnText="Borrar"
                                            isCancelBtn
                                            cancelBtnText="Cancelar"
                                            cancel
                                            onConfirm={() => {
                                              deleteTask(
                                                values,
                                                setFieldValue,
                                                index
                                              );
                                              setShowModalDelete(false);
                                            }}
                                            onClose={() =>
                                              setShowModalDelete(false)
                                            }
                                            show={showModalDelete === index}
                                          >
                                            <div>
                                              ¿Estás seguro de eliminar el
                                              riesgo penal?
                                            </div>
                                          </AppModal>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Accordion.Toggle>
                              <Accordion.Collapse
                                eventKey={`accordion${index}`}
                                className="ac-body"
                              >
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div style={{ marginBottom: '1rem' }}>
                                      <h3>Probabilidad</h3>
                                    </div>
                                    <AppSingleSelect
                                      options={probabilityArray.workers}
                                      title="Nº empleados"
                                      value={
                                        values.directions[index].probability
                                          .workers
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].probability.workers`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={probabilityArray.supervision}
                                      title="Supervisión"
                                      value={
                                        values.directions[index].probability
                                          .supervision
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].probability.supervision`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={probabilityArray.training}
                                      title="Formación"
                                      value={
                                        values.directions[index].probability
                                          .training
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].probability.training`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={probabilityArray.probability}
                                      title="Probabilidad"
                                      value={
                                        values.directions[index].probability
                                          .probability
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].probability.probability`,
                                          v
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="col-lg-6">
                                    <div style={{ marginBottom: '1rem' }}>
                                      <h3>Impacto</h3>
                                    </div>
                                    <AppSingleSelect
                                      options={impactArray.penalty}
                                      title="Pena"
                                      value={
                                        values.directions[index].impact.penalty
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].impact.penalty`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={impactArray.capacityAnswer}
                                      title="Capacidad de respuesta"
                                      value={
                                        values.directions[index].impact
                                          .capacityAnswer
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].impact.capacityAnswer`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={impactArray.damageReputation}
                                      title="Daño reputacional"
                                      value={
                                        values.directions[index].impact
                                          .damageReputation
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].impact.damageReputation`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={impactArray.impact}
                                      title="Impacto"
                                      value={
                                        values.directions[index].impact.impact
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].impact.impact`,
                                          v
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="col-lg-12" style={{ marginTop: '0.75rem' }}>
                                    <h3>Riesgo residual</h3>
                                  </div>
                                  <div className="col-lg-6">
                                    <AppSingleSelect
                                      options={riskResidualArray.prevent}
                                      title="Controles preventivos"
                                      value={
                                        values.directions[index].riskResidual
                                          .prevent
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].riskResidual.prevent`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={riskResidualArray.detect}
                                      title="Controles detectivos"
                                      value={
                                        values.directions[index].riskResidual
                                          .detect
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].riskResidual.detect`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={riskResidualArray.automatic}
                                      title="Controles automáticos"
                                      value={
                                        values.directions[index].riskResidual
                                          .automatic
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].riskResidual.automatic`,
                                          v
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="col-lg-6">
                                    <AppSingleSelect
                                      options={riskResidualArray.manual}
                                      title="Controles manuales"
                                      value={
                                        values.directions[index].riskResidual
                                          .manual
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].riskResidual.manual`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={riskResidualArray.fullControl}
                                      title="Total controles"
                                      value={
                                        values.directions[index].riskResidual
                                          .fullControl
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].riskResidual.fullControl`,
                                          v
                                        )
                                      }
                                    />
                                    <AppSingleSelect
                                      options={
                                        riskResidualArray.ineffectiveControl
                                      }
                                      title="Controles ineficaces"
                                      value={
                                        values.directions[index].riskResidual
                                          .ineffectiveControl
                                      }
                                      onChange={(v) =>
                                        setFieldValue(
                                          `directions[${index}].riskResidual.ineffectiveControl`,
                                          v
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </Accordion.Collapse>
                            </AccordionContainer>
                          ))}
                      </Accordion>
                    </div>
                  </>
                )}
              />
              <div
                style={{
                  position: 'absolute',
                  right: '2.5rem',
                  bottom: '2rem',
                }}
              >
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary mt-3"
                >
                  Guardar cambios
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Container>
  );
}

const Container = styled.div`
  height: 400px;
  overflow-y: auto;
`;

const ContainerEmpty = styled.div`
  height: 125px;
  overflow-y: auto;
`;

const AccordionContainer = styled.div`
  .ac-header {
    background-color: ${colors.grey400};
    padding: 1rem;
  }
  .ac-body {
    padding: 1rem;
  }
`;
